export default "__VITE_ASSET__796c8225__"